import Index from '@tunnel-components/@pages/supervision/systems/config/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/systems/config/index.ts